import {
  findByIdDevolusPendingActions,
  findAllDevolusPendingActions,
  resolveDevolusPendingAction,
} from '@/services/devolus/devolusService'

const state = {
  devolusPendingAction: {},
  devolusPendingActions: [],
  devolusPendingActionsTotal: 0,
  devolusPendingActionsLoading: false,
  devolusPendingActionsLoadingDetails: false,
}

const getters = {
  devolusPendingAction: (state) => state.devolusPendingAction,
  devolusPendingActions: (state) => state.devolusPendingActions,
  devolusPendingActionsTotal: (state) => state.devolusPendingActionsTotal,
  devolusPendingActionsLoading: (state) => state.devolusPendingActionsLoading,
  devolusPendingActionsLoadingDetails: (state) =>
    state.devolusPendingActionsLoadingDetails,
}

const actions = {
  async fetchDevolusPendingAction({ commit, dispatch }, id) {
    commit('setDevolusPendingActionsLoadingDetails', true)

    try {
      const { data } = await findByIdDevolusPendingActions(id)
      commit('setDevolusPendingAction', data)
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setDevolusPendingActionsLoadingDetails', false)
    }
  },

  async fetchDevolusPendingActions({ commit, dispatch, rootState }) {
    commit('setDevolusPendingActionsLoading', true)

    const defaultParams = {
      size: rootState.paginate.itemsPerPage,
      page: rootState.paginate.currentPage - 1,
      pendingActionType: 'DEVOLUS_ERROR',
      resolved: false,
    }

    const params = { ...defaultParams, ...rootState.filters.filters }

    try {
      const { data } = await findAllDevolusPendingActions(params)
      const { result, total } = data

      commit('setTotalPages', total)
      commit('setDevolusPendingActions', result)
      commit('setDevolusPendingActionsTotal', total)
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setDevolusPendingActionsLoading', false)
    }
  },

  async resolveDevolusPendingAction({ commit, dispatch }, id) {
    commit('setDevolusPendingActionsLoading', true)

    try {
      await resolveDevolusPendingAction(id)
      dispatch('fetchDevolusPendingActions')
      dispatch('showSuccessMessage', 'Devolus pending action resolved')
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setDevolusPendingActionsLoading', false)
    }
  },
}

const mutations = {
  setDevolusPendingAction: (state, devolusPendingAction) => {
    state.devolusPendingAction = devolusPendingAction
  },

  setDevolusPendingActions: (state, devolusPendingActions) => {
    state.devolusPendingActions = devolusPendingActions
  },

  setDevolusPendingActionsTotal: (state, total) => {
    state.devolusPendingActionsTotal = total
  },

  setDevolusPendingActionsLoading: (state, status) => {
    state.devolusPendingActionsLoading = status
  },

  setDevolusPendingActionsLoadingDetails: (state, status) => {
    state.devolusPendingActionsLoadingDetails = status
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}
